import React, { Component } from 'react'
import "./companyTest.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { getApiassessmentdata , getApiGetAllIndustry , getApiUserInfos } from "../../axios/api"
import {  DatePicker , message, Cascader  } from 'antd';
import { get } from '../../axios/localstorage'

export default class companyTest extends Component {


    state = {
        banner:[],
        list:[],

        show:true,

        currentIndex:0,
        nIndex:0,

        newsType:1,

        page:1,
        total:1,

        key:"",

        html:"",

        showMore:false,
        name:"",
        time:"",
        IPCount1:"",
        IPCount2:"",
        IsParticipate:true,
        TotalEmployees:"",
        TotalSci:"",
        BachelorDegree:"",
        NetAssets1:"",
        SalesRevenue1:"",
        ResearchExpenditure1:"",
        NetAssets2:"",
        SalesRevenue2:"",
        ResearchExpenditure2:"",
        NetAssets3:"",
        SalesRevenue3:"",
        ResearchExpenditure13:"",
        ThreeYearTotalAmounts:"",
        ZhAmounts:"",
        BaseAmounts:"",
        Yfactivities:"",
        LastYearTotalIncome:"",
        LastYearTotalIncomeH:"",
        IsSignAgreement:true,
        Industry:"",
        TechnicalSupport:"",
        Phone:"",

        industriesList:[],

// ResearchExpenditure13: double | 近一年的研发费用 | 是
// ThreeYearTotalAmounts: double | 近三年研究开发费用总额 | 是
// ZhAmounts: double | 研发投入其中：在中国境内研发费用总额 | 是
// BaseAmounts: double | 研发投入其中：基础研究投入费用总额 | 是
// Yfactivities: int | 近三年开展研发活动数量 | 是
// LastYearTotalIncome: double | 近一年企业总收入 | 是
// LastYearTotalIncomeH: double | 近一年高新技术产品（服务）收入 | 是
// IsSignAgreement: bool | 是否签订产学研合作协议 | 是
// Industry: string | 产业类别 | 是 (通过获取产业类别接口)
// TechnicalSupport: string | 技术支持 | 否
// Phone: string | 联系方式 | 否
    }

    componentWillMount(){
        window.scroll(0,0);

        getApiUserInfos({token:get('token')})
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                this.setState({
                    name:data.name,
                    time:data.start_date
                })
            }
        }).catch( err =>{
            console.error(err);
        })
        getApiGetAllIndustry()
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                if(data){
                    this.setState({
                        industriesList:data
                    })
                }
            }
        }).catch( err =>{
            console.error(err);
        })
    }

    componentDidMount(){
        // getApiBanner({type:2})
        // .then( req =>{
        //     if(req.data.code === 1){
        //         this.setState({
        //             banner:req.data.data
        //         })
        //     }
        // }).catch( err =>{
        //     console.error(err);
        // })
        // this.getList();
    }

    onChange=(index)=>{
        this.setState({
            currentIndex:index
        })
    }

    changePage=(page)=>{
        this.setState({
            page
        })

    }

    gotoSlide=(num)=>{
        this.refs['bslide'].goTo(num);
    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    gotoTest=()=>{

        if(!this.state.TotalSci){
            message.info("请先输入职工人数！");
            return false;
        }
        if(!this.state.TotalEmployees){
            message.info("请先输入科技人员！");
            return false;
        }
        if(!this.state.BachelorDegree){
            message.info("请先输入本科及以上学历人员！");
            return false;
        }
        
        if(!this.state.Industry){
            message.info("请先选择产业类别！");
            return false;
        }

        if(!this.state.IPCount1){
            message.info("请先输入I类知识产权数量！");
            return false;
        }
        if(!this.state.IPCount2){
            message.info("请先输入II类知识产权数量！");
            return false;
        }
        if(!this.state.NetAssets1){
            message.info("请先输入近三年的净资产！");
            return false;
        }
        if(!this.state.SalesRevenue1){
            message.info("请先输入近三年的销售收入！");
            return false;
        }
        if(!this.state.ResearchExpenditure1){
            message.info("请先输入近三年的研发费用！");
            return false;
        }
        if(!this.state.NetAssets2){
            message.info("请先输入近二年的净资产！");
            return false;
        }
        if(!this.state.SalesRevenue2){
            message.info("请先输入近二年的销售收入！");
            return false;
        }
        if(!this.state.ResearchExpenditure2){
            message.info("请先输入近二年的研发费用！");
            return false;
        }
        if(!this.state.NetAssets3){
            message.info("请先输入近一年的净资产！");
            return false;
        }
        if(!this.state.SalesRevenue3){
            message.info("请先输入近一年的销售收入！");
            return false;
        }
        if(!this.state.ResearchExpenditure13){
            message.info("请先输入近一年的研发费用！");
            return false;
        }
        if(!this.state.ThreeYearTotalAmounts){
            message.info("请先输入近三年研究开发费用总额！");
            return false;
        }
        if(!this.state.ZhAmounts){
            message.info("请先输入其中：在中国境内研发费用总额！");
            return false;
        }
        if(!this.state.BaseAmounts){
            message.info("请先输入其中：基础研究投入费用总额！");
            return false;
        }
        if(!this.state.Yfactivities){
            message.info("请先输入近三年研发立项数！");
            return false;
        }
        if(!this.state.LastYearTotalIncome){
            message.info("请先输入近一年企业总收入！");
            return false;
        }
        if(!this.state.LastYearTotalIncomeH){
            message.info("请先输入近一年高新技术产品（服务）收入！");
            return false;
        }

        let param2 = {
            "Name": this.state.name,
            "Time":this.state.time,
            "IPCount1": this.state.IPCount1?parseFloat(this.state.IPCount1):0,
            "IPCount2": this.state.IPCount2?parseFloat(this.state.IPCount2):0,
            "IsParticipate": this.state.IsParticipate,
            "TotalEmployees": this.state.TotalEmployees?parseFloat(this.state.TotalEmployees):0,
            "TotalSci":this.state.TotalSci?parseFloat(this.state.TotalSci):0,
            "BachelorDegree": this.state.BachelorDegree?parseFloat(this.state.BachelorDegree):0,
            "NetAssets1": this.state.NetAssets1?parseFloat(this.state.NetAssets1):0,
            "SalesRevenue1": this.state.SalesRevenue1?parseFloat(this.state.SalesRevenue1):0,
            "ResearchExpenditure1":this.state.ResearchExpenditure1?parseFloat(this.state.ResearchExpenditure1):0,
            "NetAssets2": this.state.NetAssets2?parseFloat(this.state.NetAssets2):0,
            "SalesRevenue2": this.state.SalesRevenue2?parseFloat(this.state.SalesRevenue2):0,
            "ResearchExpenditure2": this.state.ResearchExpenditure2?parseFloat(this.state.ResearchExpenditure2):0,
            "NetAssets3": this.state.NetAssets3?parseFloat(this.state.NetAssets3):0,
            "SalesRevenue3":this.state.SalesRevenue3?parseFloat(this.state.SalesRevenue3):0,
            "ResearchExpenditure13":this.state.ResearchExpenditure13?parseFloat(this.state.ResearchExpenditure13):0,
            "ThreeYearTotalAmounts": this.state.ThreeYearTotalAmounts?parseFloat(this.state.ThreeYearTotalAmounts):0,
            "ZhAmounts": this.state.ZhAmounts?parseFloat(this.state.ZhAmounts):0,
            "BaseAmounts":this.state.BaseAmounts?parseFloat(this.state.BaseAmounts):0,
            "Yfactivities": this.state.Yfactivities?parseFloat(this.state.Yfactivities):0,
            "LastYearTotalIncome": this.state.LastYearTotalIncome?parseFloat(this.state.LastYearTotalIncome):0,
            "LastYearTotalIncomeH": this.state.LastYearTotalIncomeH?parseFloat(this.state.LastYearTotalIncomeH):0,
            "IsSignAgreement":this.state.IsSignAgreement,
            "Industry": this.state.Industry,
            "TechnicalSupport":this.state.TechnicalSupport,
            "Phone":this.state.Phone,
             token:get('token') 
        }
        // let param = {
        //     "Name": "深圳市查策网络信息技术有限公司",
        //     "Time":'2012-02-01',
        //     "IPCount1": 1,
        //     "IPCount2": 2,
        //     "IsParticipate": true,
        //     "TotalEmployees": 20,
        //     "TotalSci":30,
        //     "BachelorDegree": 100,
        //     "NetAssets1": "1230",
        //     "SalesRevenue1": "1230",
        //     "ResearchExpenditure1": "1230",
        //     "NetAssets2": "1900",
        //     "SalesRevenue2": "1900",
        //     "ResearchExpenditure2": "1900",
        //     "NetAssets3": "2000",
        //     "SalesRevenue3": "5050",
        //     "ResearchExpenditure13": "2000",
        //     "ThreeYearTotalAmounts": "800",
        //     "ZhAmounts": "100",
        //     "BaseAmounts":"120",
        //     "Yfactivities": "6",
        //     "LastYearTotalIncome": "200",
        //     "LastYearTotalIncomeH": "120",
        //     "IsSignAgreement":"true",
        //     "Industry": "生物医药",
        //     "TechnicalSupport":"查策网",
        //     "Phone":"400-004-5577"
                
        // }

        getApiassessmentdata(param2)
        .then( req =>{
            if(req.data.code === 1){

                let data = req.data.data;

                this.setState({
                    html:data.m_StringValue,
                    show:false
                })

                window.scroll(0,0);

            }else{
                message.info(req.data.msg);
            }
        }).catch( err =>{
            console.error(err);
        })

    }


    getList=()=>{
        let param = {
            keywords:this.state.key,
            page:this.state.page,
        }

        // getApiPolicyList(param)
        // .then( req =>{
        //     if(req.data.code === 1){
        //         let data = req.data.data;
        //         this.setState({
        //             list:data.list,
        //             total:data.total
        //         })
        //     }
        // }).catch( err =>{
        //     console.error(err);
        // })
    }

    render() {
        return (
            <div className='companyTest'>
                <Header type={2} />
                <div className='head'>
                    <div className='cen'>
                        <div className='hmain'>
                            <div className='hname'>
                                <p>当前位置：</p>
                                <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p onClick={()=>{this.setState({show:true})}} className={this.state.show?'':'i_point'}>高企测评</p>
                                <img hidden={this.state.show} alt="" src="/www/assets/imgs/xiaji.png" />
                                <p hidden={this.state.show}>测评详情</p>
                            </div>

                            <div hidden={!this.state.show}>
                                <div className='hbox'>
                                    <div className='name'>
                                        <div></div>
                                        <p>基本资料</p>
                                    </div>

                                    <div className='hflex'>
                                        <div className='hdiv'>
                                            <h2>公司名称<span>*</span></h2>
                                            <div className='hitem'>
                                                <div className='hipt'>
                                                    <input type="text" placeholder='' disabled value={this.state.name} onChange={(ev)=>{this.setState({name:ev.target.value})}} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='hdiv'>
                                            <h2>成立时间<span>*</span></h2>
                                            <div className='hitem'>
                                                <div className='hipt'>
                                                <h2>{this.state.time}</h2>
                                                <DatePicker 
                                                    onChange={(value,selectedOptions)=>{
                                                        console.log(value);
                                                        console.log(selectedOptions);
                                                        this.setState({
                                                            time:selectedOptions
                                                        })
                                                    }} 
                                                    style={{borderColor:'#fff',flex:'1',opacity:'0',width:"100%",height:"100%",position:"absolute",top:"0",left:"0"}} 
                                                    placeholder=' ' size="large"  />
                                                    <img className='hicon' alt="" src="/www/assets/imgs/xiala-neirong.png" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='hflex'>
                                        <div className='hdiv hf1'>
                                            <h2>职工人数<span>*</span></h2>
                                            <div className='hnum'>
                                                <input type="number" placeholder='' maxLength={10} value={this.state.TotalSci} onChange={(ev)=>{this.setState({TotalSci:ev.target.value.length > 10?ev.target.value.slice(0,10):ev.target.value})}} />
                                                <p>{this.state.TotalSci.length}/10</p>
                                            </div>
                                        </div>
                                        <div className='hdiv hf1'>
                                            <h2>科技人员<span>*</span></h2>
                                            <div className='hnum'>
                                                <input type="number" placeholder='' maxLength={10} value={this.state.TotalEmployees} onChange={(ev)=>{this.setState({TotalEmployees:ev.target.value.length > 10?ev.target.value.slice(0,10):ev.target.value})}} />
                                                <p>{this.state.TotalEmployees.length}/10</p>
                                            </div>
                                        </div>
                                        <div className='hdiv hf1 hend'>
                                            <h2>本科及以上学历人员<span>*</span></h2>
                                            <div className='hnum'>
                                                <input type="number" placeholder='' maxLength={10} value={this.state.BachelorDegree} onChange={(ev)=>{this.setState({BachelorDegree:ev.target.value.length > 10?ev.target.value.slice(0,10):ev.target.value})}} />
                                                <p>{this.state.BachelorDegree.length}/10</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='hflex'>
                                        <div className='hdiv hf1'>
                                            <h2>产业类别<span>*</span></h2>
                                            <div className='hnum'>
                                                <h2>{this.state.Industry}</h2>
                                                <div className="casDiv">
                                                    <Cascader  fieldNames={{ label: 'fullName', value: 'value' }} popupClassName="Cascaderbox2"
                                                    style={{borderColor:'#fff',flex:'1',opacity:'0',width:"100%"}} 
                                                    placeholder=' ' size="large" options={this.state.industriesList} 
                                                    onChange={(value,selectedOptions)=>{
                                                        console.log(value);
                                                        console.log(selectedOptions)
                                                        let data = selectedOptions[0];
                                                        if(data){
                                                            this.setState({
                                                                Industry:data.fullName,
                                                            })
                                                        }
                                                    }} />
                                                </div>
                                                <div className={this.state.Industry?'himg himg2':'himg'}>
                                                    <img className='hicon' alt="" src="/www/assets/imgs/xiala-neirong.png" />
                                                    <img className='hicon2' onClick={()=>{this.setState({Industry:""})}} alt="" src="/www/assets/imgs/close4.png" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className='hdiv hf1'>
                                            <h2>技术支持<span></span></h2>
                                            <div className='hnum'>
                                                <input type="text" placeholder='' value={this.state.TechnicalSupport} onChange={(ev)=>{this.setState({TechnicalSupport:ev.target.value})}} />
                                            </div>
                                        </div>

                                        <div className='hdiv hf1 hend'>
                                            <h2>联系方式</h2>
                                            <div className='hnum'>
                                                <input type="text" placeholder='' value={this.state.Phone} onChange={(ev)=>{this.setState({Phone:ev.target.value})}} />
                                            </div>
                                        </div>
                                    </div>


                                    
                                </div>
                                <div className='hbox'>
                                    <div className='name'>
                                        <div></div>
                                        <p>知识产权情况</p>
                                    </div>

                                    <div className='hflex'>
                                        <div className='hdiv'>
                                            <h2>I类知识产权数量<span>*</span></h2>
                                            <div className='hnum hn2'>
                                                <input type="number" placeholder='' maxLength={10} value={this.state.IPCount1} onChange={(ev)=>{this.setState({IPCount1:ev.target.value.length > 10?ev.target.value.slice(0,10):ev.target.value})}} />
                                                <p>{this.state.IPCount1.length}/10</p>
                                            </div>
                                        </div>
                                        <div className='hdiv'>
                                            <h2>II类知识产权数量<span>*</span></h2>
                                            <div className='hnum hn2'>
                                                <input type="number" placeholder='' maxLength={10} value={this.state.IPCount2} onChange={(ev)=>{this.setState({IPCount2:ev.target.value.length > 10?ev.target.value.slice(0,10):ev.target.value})}} />
                                                <p>{this.state.IPCount2.length}/10</p>
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <div className='hflex'>
                                        <div className='hdiv'>
                                            <h2>参与国家或者行业标准制定</h2>
                                            <div className='single'>
                                                <div onClick={()=>{this.setState({IsParticipate:true})}} className={this.state.IsParticipate?'sin chosen':'sin'}>
                                                    <div></div>
                                                </div>
                                                <p>是</p>
                                                <div onClick={()=>{this.setState({IsParticipate:false})}} className={this.state.IsParticipate?'sin':'sin chosen'}>
                                                    <div></div>
                                                </div>
                                                <p>否</p>
                                            </div>
                                        </div>
                                    </div>

                                    
                                    
                                </div>

                                <div className='hbox'>
                                    <div className='name'>
                                        <div></div>
                                        <p>近三年经营情况（万元）</p>
                                    </div>

                                    <div className='htabel'>
                                        <table>
                                            <tr>
                                                <th className='textCenter'>年度</th>
                                                <th>2021</th>
                                                <th>2020</th>
                                                <th>2019</th>
                                            </tr>
                                            <tr>
                                                <td><h2>净资产<span>*</span></h2></td>
                                                <td> <input type="number" placeholder='' value={this.state.NetAssets3} onChange={(ev)=>{this.setState({NetAssets3:ev.target.value})}} /></td>
                                                <td><input type="number" placeholder='' value={this.state.NetAssets2} onChange={(ev)=>{this.setState({NetAssets2:ev.target.value})}} /></td>
                                                <td><input type="number" placeholder='' value={this.state.NetAssets1} onChange={(ev)=>{this.setState({NetAssets1:ev.target.value})}} /></td>
                                            </tr>
                                            <tr>
                                                <td><h2>销售收入<span>*</span></h2></td>
                                                <td><input type="number" placeholder='' value={this.state.SalesRevenue3} onChange={(ev)=>{this.setState({SalesRevenue3:ev.target.value})}} /></td>
                                                <td><input type="number" placeholder='' value={this.state.SalesRevenue2} onChange={(ev)=>{this.setState({SalesRevenue2:ev.target.value})}} /></td>
                                                <td><input type="number" placeholder='' value={this.state.SalesRevenue1} onChange={(ev)=>{this.setState({SalesRevenue1:ev.target.value})}} /></td>
                                            </tr>
                                            <tr>
                                                <td><h2>研发费用<span>*</span></h2></td>
                                                <td><input type="number" placeholder='' value={this.state.ResearchExpenditure13} onChange={(ev)=>{this.setState({ResearchExpenditure13:ev.target.value})}} /></td>
                                                <td><input type="number" placeholder='' value={this.state.ResearchExpenditure2} onChange={(ev)=>{this.setState({ResearchExpenditure2:ev.target.value})}} /></td>
                                                <td><input type="number" placeholder='' value={this.state.ResearchExpenditure1} onChange={(ev)=>{this.setState({ResearchExpenditure1:ev.target.value})}} /></td>
                                            </tr>
                                        </table>
                                    </div>

                                    <div className='hflex'>
                                        <div className='hdiv'>
                                            <h2>签订产学研合作协议</h2>
                                            <div className='single'>
                                                <div onClick={()=>{this.setState({IsSignAgreement:true})}} className={this.state.IsSignAgreement?'sin chosen':'sin'}>
                                                    <div></div>
                                                </div>
                                                <p>是</p>
                                                <div onClick={()=>{this.setState({IsSignAgreement:false})}} className={this.state.IsSignAgreement?'sin':'sin chosen'}>
                                                    <div></div>
                                                </div>
                                                <p>否</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='htm'>
                                        <div className='htext'>研发投入情况</div>
                                        <div className='htb'>
                                            <div className='hdiv'>
                                                <h2>近三年研发费用总额<span>*</span></h2>
                                                <div className='hnum2'>
                                                    <input type="number" placeholder='' value={this.state.ThreeYearTotalAmounts} onChange={(ev)=>{this.setState({ThreeYearTotalAmounts:ev.target.value})}} />
                                                    <p>万元</p>
                                                </div>
                                            </div>
                                            <div className='hflex'>
                                                <div className='hdiv'>
                                                    <h2>其中：在中国境内研发费用总额<span>*</span></h2>
                                                    <div className='hnum2'>
                                                        <input type="number" placeholder='' value={this.state.ZhAmounts} onChange={(ev)=>{this.setState({ZhAmounts:ev.target.value})}} />
                                                        <p>万元</p>
                                                    </div>
                                                </div>
                                                <div className='hdiv'>
                                                    <h2>其中：基础研究投入费用总额<span>*</span></h2>
                                                    <div className='hnum2'>
                                                        <input type="number" placeholder='' value={this.state.BaseAmounts} onChange={(ev)=>{this.setState({BaseAmounts:ev.target.value})}} />
                                                        <p>万元</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='htm'>
                                        <div className='htext'>成果转化概况</div>
                                        <div className='htb'>
                                            <div className='hdiv'>
                                                <h2>近三年研发立项数<span>*</span></h2>
                                                <div className='hnum2'>
                                                    <input type="number" placeholder='' maxLength={10} value={this.state.Yfactivities} onChange={(ev)=>{this.setState({Yfactivities:ev.target.value.length > 10?ev.target.value.slice(0,10):ev.target.value})}} />
                                                    <p>{this.state.Yfactivities.length}/10</p>
                                                </div>
                                            </div>
                                            <div className='hflex'>
                                                <div className='hdiv'>
                                                    <h2>近一年企业总收入<span>*</span></h2>
                                                    <div className='hnum2'>
                                                        <input type="number" placeholder='' value={this.state.LastYearTotalIncome} onChange={(ev)=>{this.setState({LastYearTotalIncome:ev.target.value})}} />
                                                        <p>万元</p>
                                                    </div>
                                                </div>
                                                <div className='hdiv'>
                                                    <h4>近一年高新技术产品（服务）收入<span>*</span></h4>
                                                    <div className='hnum2'>
                                                        <input type="number" placeholder='' value={this.state.LastYearTotalIncomeH} onChange={(ev)=>{this.setState({LastYearTotalIncomeH:ev.target.value})}} />
                                                        <p>万元</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className='send'>
                                    <button onClick={()=>{this.gotoTest()}}>立即测评</button>
                                </div>
                            </div>

                            <div hidden={this.state.show} className="cont" dangerouslySetInnerHTML={{
                                __html: this.state.html
                            }}></div>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        )
    }
}
